var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isArray } from 'lodash';
import { isFile } from './utils';
import { getStoreFileName } from './storage';
export function formResponseMessageVariables(message, result) {
    var msg = message;
    if ((result === null || result === void 0 ? void 0 : result._oid) && (message === null || message === void 0 ? void 0 : message.includes('${_oid}'))) {
        msg = message.replaceAll('${_oid}', result._oid);
    }
    return msg;
}
export function attachFormExtraData(fields, productConfig) {
    Object.keys(fields).map(function (field) {
        if (productConfig && fields[field].type === "partnerPayments") {
            fields[field].config = productConfig.payment;
        }
    });
    return fields;
}
export function getDataFromControlChangeEvent(field, e, currentValue) {
    var _a, _b;
    if (field.type === 'checkbox') {
        return e.target.checked;
    }
    else if (field.type === 'messenger') {
        if (!e.target.value) {
            return {};
        }
        else {
            return e.target.value;
        }
    }
    else if (field.type === 'image') {
        return e.target.files ? e.target.files[0] : undefined;
    }
    else if (field.type === 'logo') {
        var file = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.files) ? e.target.files[0] : undefined;
        if (isFile(file))
            return file;
        return (_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value;
    }
    else if (field.type === 'gallery') {
        return getGallery(e, currentValue);
    }
    else if (field.type === 'json') {
        return e.src;
    }
    else if (field.type === 'boolean') {
        if (typeof e.target.value === 'string') {
            return e.target.value === 'true';
        }
        else {
            return e.target.value;
        }
    }
    else {
        return e.target.value;
    }
}
export var getGallery = function (e, currentValue) {
    function formatValue(value) {
        if (!value)
            return null;
        if (isArray(value)) {
            var result_1 = {};
            value.map(function (i) {
                var name = getStoreFileName(i);
                result_1[name] = i;
            });
            return result_1;
        }
        return value;
    }
    var result = __assign({}, formatValue(currentValue)) || {};
    var files = e.target.files ? Array.from(e.target.files) : [];
    files.forEach(function (file) {
        if (file.size === 0) {
            result[file.name] = file;
            return;
        }
        if (!Boolean(result[file.name])) {
            result[file.name] = file;
            return;
        }
        if (isFile(result[file.name]) && result[file.name].size === 0) {
            result[file.name] = file;
            return;
        }
        alert("".concat(file.name, " \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454, \u043E\u0431\u0435\u0440\u0456\u0442\u044C \u0456\u043D\u0448\u0438\u0439"));
    });
    return result;
};
